module.exports = __webpack_public_path__ + "img/p22.a3c8c512.png";